module.exports = __webpack_public_path__ + "img/qu_es.8ba67bd.jpg";